// extracted by mini-css-extract-plugin
export default {"dynamicVariable":"blockEditor_dynamicVariable__AZ9Rx","dynamicVariableIcon":"blockEditor_dynamicVariableIcon__OF3ok"};